<template>
  <div class="p-cart">
    <!-- Cart loading -->
    <div v-if="cartLoading" class="p-cart--content p-cart--content--info">
      <span>
        <p>Loading cart...</p>
      </span>
    </div>
    <!-- Cart loading -->
    <div v-else-if="items && items.length > 0" class="p-cart--content">
      <OrderDetails ref="OrderDetails" class="p-cart--content__orderDetails" />
      <CartCoupon class="p-cart--content__couponCode" ref="CartCoupon" />
      <button
        class="p-cart--content__SignInButton a-Button--Medium a-Button--LightBlue"
        v-on:click="checkout">
        {{userId ? 'Continue' : 'Sign in to continue'}}
      </button>
    </div>
    <!-- end cart content -->
    <!-- v-else for cart length 0 -->
    <div v-else class="p-cart--content p-cart--content--info">
      <span>
        <p>Your cart is empty.</p>
        <button class="a-Button--Medium a-Button--LightBlue" v-on:click="goBack">Go back</button>
      </span>
    </div>
    <PaymentsOptionsInfo ref="PaymentsOptionsInfo"/>
  </div><!-- end cart -->
</template>

<script>
import { mapState } from 'vuex'
import CartCoupon from '../organisms/CartCoupon.vue'
import OrderDetails from '../organisms/OrderDetails.vue'
import PaymentsOptionsInfo from '../molecules/PaymentsOptionsInfo.vue'

export default {
  computed:
  mapState({
    items: state => state.cart.items,
    cartLoading: state => state.cart.fetchingCart,
    userId: state => state.user.id,
    gtmCheckoutName: state => state.globalstate.gtmCheckoutName,
    gtmProducts: state => state.cart.gtmProducts,
    gtmSent: state => state.globalstate.gtmSent,
    referrerUrl: state => state.globalstate.referrerUrl,
    loginUrl: state => state.globalstate.loginUrl
  }),

  components: {
    CartCoupon,
    OrderDetails,
    PaymentsOptionsInfo
  },

  methods: {
    checkout () {
      this.gtmCheckoutTrigger()
      if (this.userId) {
        this.$router.push({ path: '/payment' })
      } else {
        window.location.href = this.loginUrl
      }
    },
    gtmAddTrigger () {
      const options = {
        'event': 'eec-addToCart',
        'checkout_type': this.gtmCheckoutName,
        'ecommerce': {
          'add': {
            'products': this.gtmProducts
          }
        }
      }
      if (this.userId !== '') {
        options['userId'] = this.userId
      }
      this.$gtm.trackEvent(
        options
      )
    },
    gtmCheckoutTrigger () {
      const options = {
        'event': 'eec-checkout',
        'checkout_type': this.gtmCheckoutName,
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1 },
            'products': this.gtmProducts
          }
        }
      }
      if (this.userId !== '') {
        options['userId'] = this.userId
      }
      this.$gtm.trackEvent(
        options
      )
    },
    goBack () {
      document.location.href = this.referrerUrl
    },
    showOrderTotal () {
      this.$store.dispatch('globalstate/updateShowOrderTotal', false)
    },
    updateHeader () {
      this.$store.dispatch('globalstate/updateHeaderCaption', 'Your order')
    },
    sendOptimizeActivationEvent () {
      const dataLayer = window.dataLayer || []
      dataLayer.push({ 'event': 'optimize.activate' })
    }
  },
  mounted () {
    this.$nextTick(() => {
      // Apply Google Optimize changes
      this.sendOptimizeActivationEvent()
    })
  },
  beforeDestroy () {
    // Revert Google Optimize changes
    this.sendOptimizeActivationEvent()
  },
  created () {
    this.showOrderTotal()
    this.updateHeader()
  },
  updated () {
    if (!this.gtmSent && this.gtmProducts.length > 0) {
      this.gtmAddTrigger()
      this.$store.dispatch('globalstate/setGtmSentFlag')
    }
  },
  data () {
    return {
      subTotal: 0,
      promotionDescription: '',
      promotionOriginalPrice: 0,
      promotionProductBillingPeriod: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// Cart.vue?3d0907b2